import type { NotifyPort } from '@/features/messages/domain/notify'
import type { Customer, CustomerFilter, CustomerPort } from '../domain/customer'

const listCustomers = async (port: CustomerPort, filter: CustomerFilter, notify: NotifyPort): Promise<Customer[]> => {
	try {
		return await port.list(filter)
	} catch (err) {
		notify.error('customer.loadFailed')
		throw err
	}
}

export { listCustomers }
